import { AutogenModelCarrierInsCtrl, AutogenRowCarrierInsCtrl } from "./autogen/AutogenModelCarrierInsCtrl";

export class ModelCarrierInsCtrl extends AutogenModelCarrierInsCtrl<RowCarrierInsCtrl> {
    constructor() {
        super(RowCarrierInsCtrl);
    }
}

export class RowCarrierInsCtrl extends AutogenRowCarrierInsCtrl {
}